import { render } from "./FindBusOtherCity.vue?vue&type=template&id=283ca0f8&ts=true"
import script from "./FindBusOtherCity.vue?vue&type=script&lang=ts"
export * from "./FindBusOtherCity.vue?vue&type=script&lang=ts"

import "./FindBusOtherCity.vue?vue&type=style&index=0&id=283ca0f8&lang=scss"

import exportComponent from "/Users/phoebe/projects/find-bus-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__